// LawPay dashboard refunds/voids arrive on a payment as status_label
// ("Refunded", "Partially refunded") and refunds[] { amount, method, date,
// invoices | reverses }. Older payloads omit both. Delivered 2026-11-01.

export function paymentStatusLabel(payment) {
  if (!payment) return '';
  const raw = payment.status_label;
  if (typeof raw !== 'string' && typeof raw !== 'number') return '';
  return String(raw).trim();
}

// partial before refund so "Partially refunded" does not take the full-refund tone.
export function paymentStatusTone(label, status) {
  const text = `${label || ''} ${status || ''}`.toLowerCase();
  if (text.includes('partial')) return 'partial';
  if (text.includes('refund')) return 'refunded';
  if (text.includes('void')) return 'voided';
  if (text.includes('revers')) return 'reversed';
  if (text.includes('fail') || text.includes('declin')) return 'failed';
  if (text.includes('pend') || text.includes('process')) return 'pending';
  return 'cleared';
}

function plainText(value) {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return '';
}

function invoiceFromObject(obj) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return '';
  const num = obj.invoice_number ?? obj.number ?? obj.invoice ?? obj.label ?? obj.name;
  const text = plainText(num);
  if (!text) return '';
  if (/^#/.test(text) || /invoice/i.test(text)) return text;
  if (/^\d+$/.test(text)) return `#${text}`;
  return text;
}

// invoices and reverses may be a display string, a list, or { invoice_number }.
export function invoiceReversalText(value) {
  if (value == null || value === false) return '';
  if (Array.isArray(value)) {
    return value.map(invoiceReversalText).filter(Boolean).join(', ');
  }
  const plain = plainText(value);
  if (plain) return plain;
  return invoiceFromObject(value);
}

export function refundInvoiceText(refund) {
  if (!refund || typeof refund !== 'object') return '';
  const fromReverses = invoiceReversalText(refund.reverses);
  if (fromReverses) return fromReverses;
  return invoiceReversalText(refund.invoices);
}

export function refundReversesLabel(refund) {
  const text = refundInvoiceText(refund);
  if (!text) return '';
  if (/^reverses\b/i.test(text)) return text;
  return `Reverses ${text}`;
}

export function refundWhen(refund) {
  if (!refund || typeof refund !== 'object') return '';
  return plainText(refund.date) || plainText(refund.refund_date) || '';
}

export function refundAmount(refund) {
  if (!refund || typeof refund !== 'object') return null;
  if (refund.amount == null || refund.amount === '') return null;
  const n = Number(refund.amount);
  return Number.isFinite(n) ? n : null;
}

export function listRefunds(payment) {
  if (!payment) return [];
  const raw = Array.isArray(payment.refunds)
    ? payment.refunds
    : (Array.isArray(payment.payment_refunds) ? payment.payment_refunds : null);
  if (!raw) return [];
  return raw.filter((r) => r && typeof r === 'object');
}
